import type { IOption } from '~/domains/career/components/career-searchBar/career-searchBar.types'

export const CITIES: IOption[] = [
  {
    label: 'Cała Polska',
    header: 'Cała Polska',
    key: '',
  },
  {
    header: 'Warszawa',
    label: 'Warszawa',
    key: 'Warszawa',
  },
  {
    header: 'Wrocław',
    label: 'Wrocław',
    key: 'Wrocław',
  },
  {
    header: 'Poznań',
    label: 'Poznań',
    key: 'Poznań',
  },
  {
    header: 'Rzeszów',
    label: 'Rzeszów',
    key: 'Rzeszów',
  },
  {
    header: 'Gdańsk',
    label: 'Gdańsk',
    key: 'Gdańsk',
  },
  {
    header: 'Kraków',
    label: 'Kraków',
    key: 'Kraków',
  },
  {
    header: 'Toruń',
    label: 'Toruń',
    key: 'Toruń',
  },
  {
    header: 'Zielona Góra',
    label: 'Zielona Góra',
    key: 'Zielona Góra',
  },
]

export const AREAS: IOption[] = [
  {
    key: 'technology',
    header: 'Technologie',
    label: 'Technologie',
  },
  {
    key: 'sell',
    header: 'Sprzedaż',
    label: 'Sprzedaż',
  },
  {
    key: 'service',
    header: 'Obsługa',
    label: 'Obsługa',
  },
  {
    key: 'others',
    header: 'Pozostałe',
    label: 'Pozostałe',
  },
  {
    key: 'interships',
    header: 'Praktyki i Staże',
    label: 'Praktyki i Staże',
  },
]

export const categoriesMap: Record<string, string> = {
  Technologie: 'technologie',
  Sprzedaż: 'sprzedaz',
  Obsługa: 'obsluga',
  Pozostałe: 'pozostale',
  'Praktyki i Staże': 'praktyki-staze',
}

export const defaultCategory = 'wszystkie-oferty'
